<template>
  <div class="security-container">
    <div class="security-card">
      <div class="icon">
        ⚠️
      </div>

      <h1>ALERTA DE SEGURIDAD</h1>

      <p class="message">
        Se detectó el uso de herramientas de inspección o depuración del navegador.
      </p>

      <p class="message">
        Por motivos de seguridad, el acceso al sistema ha redireccionado al inicio de sesión.
      </p>

      <div class="warning-box">
        <strong>IMPORTANTE</strong>
        <br />
        Todas las acciones realizadas dentro del sistema pueden ser registradas y auditadas.
      </div>

      <button class="btn-return" @click="goLogin">
        Volver al inicio de sesión
      </button>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";

const router = useRouter();

const goLogin = () => {
  localStorage.clear();
  localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("auth");

  sessionStorage.setItem("security_blocked", "true");

  router.replace("/sign-in");
};
</script>

<style scoped>
.security-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #111827;
  padding: 20px;
}

.security-card {
  max-width: 700px;
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
}

.icon {
  font-size: 80px;
  margin-bottom: 20px;
}

h1 {
  color: #dc2626;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 25px;
}

.message {
  font-size: 18px;
  color: #374151;
  line-height: 1.6;
  margin-bottom: 15px;
}

.warning-box {
  margin-top: 25px;
  margin-bottom: 30px;
  padding: 20px;
  border-radius: 8px;
  background: #fef2f2;
  border: 1px solid #fca5a5;
  color: #991b1b;
}

.btn-return {
  border: none;
  background: #dc2626;
  color: white;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: 0.2s;
}

.btn-return:hover {
  background: #b91c1c;
}
</style>